import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="w-full max-w-sm bg-card rounded-2xl p-8 rise-in" style={{ boxShadow: "0 8px 32px rgba(31,61,63,0.10)" }}>
        <img src="/tag-logo.png" alt="TAG logo" className="w-20 h-20 rounded-full object-contain mb-5 shadow-sm" />
        <p className="overline-label text-primary">CEO Command Center</p>
        <h1 className="font-display text-2xl sm:text-3xl tracking-tight mt-1 mb-7 text-primary">TAGCOMMAND</h1>
        <form onSubmit={submit} className="space-y-3">
          <input
            data-testid="login-email-input"
            type="email"
            className="tactical-input"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            data-testid="login-password-input"
            type="password"
            className="tactical-input"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {error && (
            <p data-testid="login-error" className="text-destructive text-sm">{error}</p>
          )}
          <button
            data-testid="login-submit-button"
            disabled={loading}
            className="w-full h-12 bg-primary text-primary-foreground font-bold uppercase tracking-widest text-sm tap-btn disabled:opacity-50"
          >
            {loading ? "Authenticating..." : "Enter"}
          </button>
        </form>
      </div>
    </div>
  );
}
